import { render, staticRenderFns } from "./ExcluirProdutoDialog.vue?vue&type=template&id=763e90ed&scoped=true&"
import script from "./ExcluirProdutoDialog.vue?vue&type=script&lang=js&"
export * from "./ExcluirProdutoDialog.vue?vue&type=script&lang=js&"
import style0 from "./ExcluirProdutoDialog.vue?vue&type=style&index=0&id=763e90ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763e90ed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VDialog,VRow})
